<app-segov-sigepo-portal-body>
  <app-segov-sigepo-header-section [Title]="titulo" [RouteStack]="RouteStack">
  </app-segov-sigepo-header-section>

  <div class="grupo-colunas-dados-contato">
    <div style="padding: 0 0.8rem">
      <h3 style="font-weight: 600; color: var(--tom-2-informativo)">Canais de <br class="exibe-tela-menor-1200"> atendimento a clientes:</h3>
      <h4 class="subtitulo-atendimento">Escolha o canal mais adequado para a sua necessidade e fale com a gente:</h4>
    </div>
    <div class="row" style="margin: 0; padding-top: 1.5rem;">
      <div class="col-lg-6 col-12 cards-ajuda-collection-col-left">
        @for (dado of colunaAtendimento; track $index){
        <app-atendimento-card [Title]="dado.titulo" [Icons]="dado.icons" [Topic]="dado.topico"
          [Emphasis]="dado.emphasis" [CustomStyleBody]="'padding-top: 1rem; padding-bottom: 1rem'">
          <p>{{dado.descricao}}</p>
        </app-atendimento-card>
        }
      </div>
      <div class="col-lg-6 col-12 cards-ajuda-collection-col-right">
        <app-atendimento-card [Title]="cardCanalMensagens.titulo" [Icons]="cardCanalMensagens.icons"
          [Topic]="cardCanalMensagens.topico" [Emphasis]="cardCanalMensagens.emphasis"
          [CustomStyleBody]="'padding-top: 1rem; padding-bottom: 1rem'">
          <lib-segov-sigepo-rounded-button [baseStyle]="'segov-rounded-button-with-border'" [width]="'240px'"
            [customStyle]="'letter-spacing: 1px; border-radius: 5px; margin-top: 16px'"
            (click)="goToPage(cardCanalMensagens)" (keyup.enter)="goToPage(cardCanalMensagens)">
            {{cardCanalMensagens?.buttonName}}
          </lib-segov-sigepo-rounded-button>
        </app-atendimento-card>

        <app-atendimento-card [Title]="cardEndereco.titulo" [Icons]="cardEndereco.icons" [Topic]="cardEndereco.topico"
          [Emphasis]="cardEndereco.emphasis" [IconPosition]="'below'"
          [CustomStyleCard]="'min-height: 330px; line-height: 1.3rem;'"
          [CustomStyleBody]="'padding-top: 1rem; padding-bottom: 1rem'">
          <p>{{cardEndereco.descricao}}</p>
        </app-atendimento-card>
      </div>
    </div>
  </div>

  <div class="row grupo-colunas-ajuda" style="margin: 0">
    <div class="col-lg-6 col-12 cards-collection-col cards-ajuda-collection-col ajuda-col">
      <div style="display: flex; flex-direction: row; align-items: center; margin: 2rem 0;">
        <h3 style="font-weight: bold;">Como <br> podemos ajudar?</h3>
      </div>
      @for (dado of colunaAjuda; track $index){
      <app-atendimento-card [Title]="dado.titulo" [Icons]="dado.icons" [SideBorder]="'all'" [Emphasis]="dado.emphasis"
        [CustomStyleBody]="'padding: 2rem 1rem'" [IconPosition]="'below'">
        <p>{{dado.descricao}}</p>
        <lib-segov-sigepo-rounded-button [baseStyle]="'segov-rounded-button-with-border'" [width]="'256px'"
          [customStyle]="'border-radius: 5px; letter-spacing: 1px;'" (click)="goToPage(dado)"
          (keyup.enter)="goToPage(dado)">
          {{dado?.buttonName}}
        </lib-segov-sigepo-rounded-button>
      </app-atendimento-card>
      }
    </div>

    <div class="col-lg-6 col-12 email-form-group">
      <div class="enviar-email-col">
        <div class="email-form-content">
          <app-enviar-email-contato></app-enviar-email-contato>
        </div>
      </div>
    </div>
  </div>
</app-segov-sigepo-portal-body>
